import { render, staticRenderFns } from "./kuang.vue?vue&type=template&id=4322a6e4&scoped=true"
import script from "./kuang.vue?vue&type=script&lang=js"
export * from "./kuang.vue?vue&type=script&lang=js"
import style0 from "./kuang.vue?vue&type=style&index=0&id=4322a6e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322a6e4",
  null
  
)

export default component.exports